import {createUseStyles} from 'react-jss';

export default createUseStyles({
  ThreeDSecureContainer: {
    minHeight: '500px',
  },
  loading: {
    textAlign: 'center',
  },
});
